import { Directive } from '@angular/core';

@Directive({
  selector: '[aria]'
})
export class AriaDirective {

    static concatAriaStrings(colList:string[], dataList:string[]){
        let rowConcat:string = '';

        if(colList.length == dataList.length){
            for(var i = 0; i < colList.length; i++){
                rowConcat += colList[i] +' ' + (dataList[i] != null ? dataList[i] : '') + '. ';
            }
        }

        return rowConcat;
    }    

}
